module.exports = __webpack_public_path__ + "img/icon_total_gray.c3b038db.png";